import React from 'react';
import { SvgIcon } from '@mui/material';
import PropTypes from 'prop-types';

const EditSecondaryIcon = (props) => (
  <SvgIcon {...props}>
    <path
      d="M5 3C3.895 3 3 3.895 3 5V19C3 20.105 3.895 21 5 21H16.1719L13.293 18.1211C13.105 17.9341 13 17.6791 13 17.4141V14C13 13.448 13.448 13 14 13H17.4141C17.6791 13 17.9341 13.105 18.1211 13.293L21 16.1719V5C21 3.895 20.105 3 19 3H5ZM7 6H17C17.552 6 18 6.448 18 7C18 7.552 17.552 8 17 8H7C6.448 8 6 7.552 6 7C6 6.448 6.448 6 7 6ZM7 10H10C10.552 10 11 10.448 11 11C11 11.552 10.552 12 10 12H7C6.448 12 6 11.552 6 11C6 10.448 6.448 10 7 10ZM15 15V17L20.1465 22.1465L22.1465 20.1465L17 15H15ZM22.8535 20.8535L20.8535 22.8535L21.5859 23.5859C22.1379 24.1379 23.0339 24.1379 23.5859 23.5859C24.1379 23.0339 24.1379 22.1379 23.5859 21.5859L22.8535 20.8535Z"
      fill={props.sx?.color || '#080F1D'}
    />
  </SvgIcon>
);

EditSecondaryIcon.propTypes = {
  sx: PropTypes.object,
};

export default EditSecondaryIcon;
